import React, {
  Component, Fragment, useEffect, useState,
} from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Avatar, Dropdown, Select, Tooltip,
} from 'antd';
import TenantActions from '@Actions/tenantActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUserPlus, faSearch, faClose,
} from '@fortawesome/free-solid-svg-icons';
import './style.scss';
import { LoadingOutlined } from '@ant-design/icons';
import Helpers from '@Apis/helpers';

function SelectUser({
  user, orgUsers, tenantId, selectedUsers, onSelect, onRemove, disabled, userList, singleSelect, getPopupContainer, dontShowUnassigned, removeAddUser,
}) {
  const [showActionDropdown, setShowActionDropdown] = useState(false);
  const [keyword, setKeyword] = useState('');

  const getUserList = () => {
    if (userList) return userList;
    return orgUsers?.data;
  };

  return (
    <div>
      <Dropdown
        disabled={disabled}
        overlay={(
          <div className="select-user__dropdown">
            <div className="select-user__dropdown-input">
              <div className="select-user__dropdown-padding" />
              <div className="select-user__dropdown-input-inner">
                <FontAwesomeIcon icon={faSearch} />
                <input value={keyword} onChange={(event) => setKeyword(event.target.value)} />
              </div>
            </div>
            <div className="select-user__dropdown-list">
              {!dontShowUnassigned && (
                <div
                  key={0}
                  className={`select-user__dropdown-item ${selectedUsers?.find((i) => i?.userId === 0) ? 'select-user__dropdown-item-selected' : ''}`}
                  onClick={() => (selectedUsers?.find((i) => i?.userId === 0) ? onRemove(0) : onSelect(0))}
                >
                  <Avatar
                    style={{
                      backgroundColor: 'grey',
                    }}
                  >
                    UA
                  </Avatar>
                  &nbsp;
                  Unassigned
                  <span className="select-user__dropdown-item-close">
                    <FontAwesomeIcon icon={faClose} />
                  </span>
                </div>
              )}
              {getUserList()
                ?.filter((item) => item?.first_name?.toLowerCase()?.includes(keyword?.toLowerCase()) || item?.last_name?.toLowerCase()?.includes(keyword?.toLowerCase()))
                ?.map((item) => (
                  <div
                    key={item?.user_id}
                    className={`select-user__dropdown-item ${selectedUsers?.find((i) => i?.userId === item?.user_id) ? 'select-user__dropdown-item-selected' : ''}`}
                    onClick={() => (selectedUsers?.find((i) => i?.userId === item?.user_id) ? onRemove(item?.user_id) : onSelect(item?.user_id))}
                  >
                    <Avatar
                      style={{
                        backgroundColor: Helpers.getAvatarColors(item?.first_name?.[0])?.color1,
                      }}
                    >
                      {item?.first_name.substring(0, 2).toUpperCase()}
                    </Avatar>
                    &nbsp;
                    {`${item?.first_name} ${item?.last_name}`?.trim()}
                    <span className="select-user__dropdown-item-close">
                      <FontAwesomeIcon icon={faClose} />
                    </span>
                  </div>
                ))}
              {!orgUsers && (
                <div style={{ textAlign: 'center', marginTop: '50px' }}>
                  <LoadingOutlined />
                </div>
              )}
            </div>
          </div>
        )}
        trigger={['click']}
        placement="bottom"
        getPopupContainer={getPopupContainer}
        onOpenChange={(visible) => {
          if (!visible) {
            setKeyword('');
          }
        }}
      >
        <div style={{ display: 'flex', cursor: 'pointer' }}>
          <Avatar.Group
            maxCount={2}
            maxStyle={{
              color: '#f56a00',
              backgroundColor: '#fde3cf',
            }}
          >
            {selectedUsers?.map((userProfile) => (
              <Tooltip key={userProfile?.userId} title={userProfile?.title} placement="top">
                <Avatar
                  style={{
                    backgroundColor: Helpers.getAvatarColors(userProfile?.identity?.[0])?.color1,
                  }}
                  className="select-user__avatar"
                >
                  {userProfile?.identity}
                </Avatar>
              </Tooltip>
            ))}
          </Avatar.Group>
          {!removeAddUser && !singleSelect && (
            <div className="select-user__cta" style={{ fontSize: '12px', marginLeft: selectedUsers?.length ? '-10px' : '0px' }}>
              <FontAwesomeIcon icon={faUserPlus} />
            </div>
          )}
          {!removeAddUser && singleSelect && !selectedUsers?.length && (
            <div className="select-user__cta" style={{ fontSize: '12px', marginLeft: selectedUsers?.length ? '-10px' : '0px' }}>
              <FontAwesomeIcon icon={faUserPlus} />
            </div>
          )}
        </div>
      </Dropdown>
    </div>
  );
}

const mapStateToProps = ({ UserReducers, TenantReducers }) => ({
  getOrgUsersLoading: TenantReducers.getOrgUsersLoading,
  orgUsers: TenantReducers.orgUsers,
});

const mapDispatchToProps = (dispatch) => ({
  getUsers: (tenantIds, callback) => dispatch(TenantActions.getOrgUsers(tenantIds, callback)),
});

SelectUser.propTypes = {
  orgUsers: PropTypes.any,
  users: PropTypes.any,
  getUsers: PropTypes.func,
  disabled: PropTypes.bool,
  title: PropTypes.any,
  hideTitle: PropTypes.bool,
  tenantId: PropTypes.any,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(SelectUser));
